import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { extractBestTranslation } from '@/utils/helpers';

const FieldName = ({ field }) => {
    const { t, i18n } = useTranslation();
    
    const label = extractBestTranslation(field.label, i18n.language);
    
    return label ? (
        <Typography sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
        }}>
            {label}
        </Typography>
    ) : (
        <Typography sx={{ fontStyle: 'italic', color: 'text.secondary' }}>{t('Unnamed field')}</Typography>
    );
};

export default FieldName;
